<script lang="ts">
  import { isUserLoggedIn, user } from "../app.store";
  import { logout } from "../app.logic";
  import { APP_TITLE } from "../utils/constants";

  let appTitle = APP_TITLE;
  let showUserMenu = true;
  $: userFullName = $user != null ? $user.fullName : "";
  $: companyName = $user != null ? $user.regionSettings.companyName : "";
</script>

<nav class="navbar header-navbar noselect">
  <div class="container content header-content">
    <div class="navbar-brand header-brand">
      <i class="navbar-item">
        <img src="/img/logo.png" alt="Logo" />
      </i>

      <a class="navbar-item brand-text header-brand-text" href="/">
        {appTitle}
      </a>

      <span class="navbar-item brand-text header-brand-text">
        {companyName}
      </span>
    </div>

    <div class="navbar-end">
      {#if $isUserLoggedIn}
        {#if showUserMenu}
          <a class="navbar-item header-user-name" href="/profile">
            {userFullName}
          </a>
        {/if}

        <div class="navbar-item">
          <div class="buttons">
            <button class="button is-light" on:click={logout}>
              <strong>Logout</strong>
            </button>
          </div>
        </div>
      {/if}
    </div>
  </div>
</nav>

<style>
  .header-navbar {
    background-color: #ededed;
    border-bottom: 1px solid #d9dee4;
    height: 4rem;
  }

  .header-content {
    max-width: unset !important;
    padding-left: 3rem;
    border-bottom: 1px solid #f2f2f2;
    display: flex !important;
  }

  .header-brand {
    flex: 1;
  }

  .header-brand-text {
    font-weight: 300;
    padding-right: 5rem;
  }

  .header-user-name {
    border: none;
  }

  .header-user-name:hover,
  .header-user-name:focus,
  .header-user-name:focus-within {
    background-color: #ededed;
    outline: none;
  }
</style>
